export default __webpack_public_path__ + "static/ceinture4.inspirations-6aa61248b44681f1678d0f9dad5a25c5.jpg";